module.exports = __webpack_public_path__ + "static/media/20201129_222344_610_IMG_1960.a79d418e.jpg";